import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class NutzungsgradWaermeerzeugerHeizung extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    waermeerzeuger_heizung_id: number | null = null;
    installationsperiode_id: number | null = null;
    nutzungsgrad: number | null = null;

    // view fields:
    waermeerzeuger_heizung: string | null = null;
    waermeerzeuger_reihenfolge: number | null = null;
    installationsperiode: string | null = null;
    installationsperiode_reihenfolge: number | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'NutzungsgradWaermeerzeugerHeizung';
    }
}

export async function createNewNutzungsgradWaermeerzeugerHeizung(): Promise<NutzungsgradWaermeerzeugerHeizung> {
    const nutzungsgradwaermeerzeugerheizung = createModel(NutzungsgradWaermeerzeugerHeizung, {});

    await nutzungsgradwaermeerzeugerheizung.save();
    return nutzungsgradwaermeerzeugerheizung;
}

export class NutzungsgradWaermeerzeugerHeizungCollection extends BaseCollection<NutzungsgradWaermeerzeugerHeizung> {
    protected modelCls = NutzungsgradWaermeerzeugerHeizung;

    public getModelClassName(): string {
        return 'NutzungsgradWaermeerzeugerHeizung';
    }
}
